export default __webpack_public_path__ + "static/xr_glasses_m-7c799b2e566ad78dfa586e332694c6ce.png";